import { UserRolesEnum } from '@sparling/financial-common'
import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export enum Status {
  Pending = 'pending',
  Approved = 'approved',
}

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'settlement/get-addresses',
  columns: [
    {
      id: 'identifier',
      label: 'IDENTIFIER',
      // eslint-disable-next-line
      format: (value: string) => {
        let newValue = ''
        if (value) {
          newValue = value.length <= 6 ? value : `${value.substr(0, 6)}...`
        }
        return newValue
      },
    },
    {
      id: 'asset',
      label: 'CURRENCY',
    },
    {
      id: 'address',
      label: 'IBAN/ACCOUNT',
      // eslint-disable-next-line
      format: (value: string) => {
        let newValue = ''
        if (value) {
          newValue = value.length <= 9 ? value : `${value.substr(0, 9)}...`
        }
        return newValue
      },
    },
    {
      id: 'statusSA',
      label: 'STATUS',
      format: (value: string) => value.replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
    },
    {
      id: 'editIcon',
      label: '',
      roles: [UserRolesEnum.ADMIN, UserRolesEnum.ACCOUNTANT],
    },
  ],
}
